import { render, staticRenderFns } from "./LoadingLavorazioneDettaglio.vue?vue&type=template&id=344add06"
import script from "./LoadingLavorazioneDettaglio.vue?vue&type=script&lang=ts"
export * from "./LoadingLavorazioneDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('344add06')) {
      api.createRecord('344add06', component.options)
    } else {
      api.reload('344add06', component.options)
    }
    module.hot.accept("./LoadingLavorazioneDettaglio.vue?vue&type=template&id=344add06", function () {
      api.rerender('344add06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingLavorazioneDettaglio.vue"
export default component.exports